import Day from "./Day";

export default class Period {
  days = [];
  period = 1;

  constructor(period, days) {
    this.period = period;
    Period.convertDays(days).forEach((d, dIndex) => {
      this.days.push(
        new Day(
          d.weeknum || dIndex + 1,
          d.open,
          d.close,
          d.active,
          d.nextDay,
          d.periodOfNextDay
        )
      );
    });
  }

  //Coverte o modelo de horários antigo para o novo
  static convertDays(e) {
    const times = [];
    for (let hours = 0; hours < 24; hours++) {
      for (let minutes = 0; minutes < 4; minutes++) {
        times.push(
          `${`${hours}`.padStart(2, "0")}${`${minutes * 15}`.padStart(2, "0")}`
        );
      }
    }

    e.map((item, i) => {
      //Se o formato de abertura não for compatível com o atual
      if (!Array.isArray(item.open)) {
        if (item.open) {
          item.open = [String(item.open)];
        } else {
          item.open = [times[0]];
        }

        if (item.close) {
          item.close = [String(item.close)];
        } else {
          const openTime = times.indexOf(item.open[0]);
          item.close = [times[(openTime + 1) % times.length]];
        }
      }

      return item;
    });

    return e;
  }

  toJSON() {
    return this;
  }
}
